import { RouteNames } from '@/router';

export interface NavLink {
  name: string;
  titleKey: string;
  children?: NavLink[];
}

const mainLinks: NavLink[] = [
  { name: 'tacho', titleKey: 'nav.tacho' },
  {
    name: 'details',
    titleKey: 'nav.details',
    children: [
      { name: RouteNames.detailsOverall, titleKey: 'nav.eventsOverall' },
      { name: RouteNames.detailsPorts, titleKey: 'nav.eventsByPorts' },
      { name: RouteNames.detailsUrls, titleKey: 'nav.eventsByUrls' },
    ],
  },
  { name: 'about', titleKey: 'nav.about' },
];

export const useNavigation = () => {
  return { mainLinks };
};
